import { useLiveQuery } from 'dexie-react-hooks';
import { replica } from '@/shared/sync/replica';

/** Deleted records of every collection, most recently deleted first. */
export function useTrash() {
  return useLiveQuery(async function loadTrash() {
    const views = await replica.listAll();
    return views
      .filter((view) => view.deleted_at)
      .sort((a, b) => (b.deleted_at ?? '').localeCompare(a.deleted_at ?? ''));
  });
}
